import actionTypes from './actionTypes';
import api from 'src/utils/api';
import { setAlert } from 'src/typescript/components/alert/actions';
import * as log from 'loglevel';

export const fetchProfile = () => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PROFILE });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const response = await api.get(`private/users/${currentUser.userId}/profile`);
      dispatch({
        type: actionTypes.FETCH_PROFILE_SUCCESS,
        data: response.data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_PROFILE_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const updateProfile = (profileData) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_PROFILE });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const { data } = await api.post(`private/users/${currentUser.userId}/profile`, { profileData });
        dispatch({
          type: actionTypes.UPDATE_PROFILE_SUCCESS,
          data,
        });
        resolve();
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.UPDATE_PROFILE_FAILURE, error: ex });
        dispatch(setAlert(ex.message));
        reject();
      }
    });
  };
};

export const updateBasics = (basicData) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_PROFILE_BASICS });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const { data } = await api.put(`private/users/${currentUser.userId}/profile/basics`, {
          'basic-data': basicData,
        });
        dispatch({
          type: actionTypes.UPDATE_PROFILE_BASICS_SUCCESS,
          data,
        });
        resolve();
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.UPDATE_PROFILE_BASICS_FAILIRE, error: ex });
        dispatch(setAlert(ex.message));
        reject();
      }
    });
  };
};

export const updateBio = (bio) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_PROFILE_BIO });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const { data } = await api.auroraPut('profile/about', {
          aboutMe: bio,
          userId: currentUser.userId,
        });
        dispatch({
          type: actionTypes.UPDATE_PROFILE_BIO_SUCCESS,
          bio,
        });
        resolve();
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.UPDATE_PROFILE_BIO_FAILURE, error: ex });
        dispatch(setAlert(ex.message));
        reject();
      }
    });
  };
};

export const updateCondition = (id, condition) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_PROFILE_CONDITION });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const { data } = await api.put(`private/users/${currentUser.userId}/profile/conditions/${id}`, {
          condition,
        });
        dispatch({
          type: actionTypes.UPDATE_PROFILE_CONDITION_SUCCESS,
          condition: data,
        });
        resolve();
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.UPDATE_PROFILE_CONDITION_FAILURE, error: ex });
        dispatch(setAlert(ex.message));
        reject();
      }
    });
  };
};

export const addInterests = (interestList) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.ADD_PROFILE_INTERESTS });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const { data: { interests } } = await api.post(`private/users/${currentUser.userId}/profile`, {
          'profile-data': {
            interests: interestList,
          },
        });
        dispatch({
          type: actionTypes.ADD_PROFILE_INTERESTS_SUCCESS,
          interests,
        });
        resolve();
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.ADD_PROFILE_INTERESTS_FAILURE, error: ex });
        dispatch(setAlert(ex.message));
        reject();
      }
    });
  };
};

export const updateInterestPrivacy = (id, isPrivate) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_PROFILE_INTEREST_PRIVACY });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const { data } = await api.put(`private/users/${currentUser.userId}/profile/interests/${id}`, {
          interest: {
            isPrivate,
          },
        });
        dispatch({
          type: actionTypes.UPDATE_PROFILE_INTEREST_PRIVACY_SUCCESS,
          interest: data,
        });
        resolve();
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.UPDATE_PROFILE_INTEREST_PRIVACY_FAILURE, error: ex });
        dispatch(setAlert(ex.message));
        reject();
      }
    });
  };
};

export const deleteCondition = (id) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.DELETE_PROFILE_CONDITION });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const response = await api.del(`private/users/${currentUser.userId}/profile/conditions/${id}`);
        dispatch({
          type: actionTypes.DELETE_PROFILE_CONDITION_SUCCESS,
          id,
        });
        resolve();
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.DELETE_PROFILE_CONDITION_FAILURE, error: ex });
        dispatch(setAlert(ex.message));
        reject();
      }
    });
  };
};

export const deleteInterest = (id) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.DELETE_PROFILE_INTEREST });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const response = await api.del(`private/users/${currentUser.userId}/profile/interests/${id}`);
        dispatch({
          type: actionTypes.DELETE_PROFILE_INTEREST_SUCCESS,
          id,
        });
        resolve();
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.DELETE_PROFILE_INTEREST_FAILURE, error: ex });
        dispatch(setAlert(ex.message));
        reject();
      }
    });
  };
};

export const uploadPreviewAvatarImage = (formData) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.UPLOAD_PREVIEW_AVATAR_IMAGE });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        formData.append('userId', currentUser.userId);
        const { data: { payload, status } } = await api.auroraPost('profile/picture', formData);

        if (!status.success) {
          throw new Error(status.message);
        }

        dispatch({
          type: actionTypes.UPLOAD_PREVIEW_AVATAR_IMAGE_SUCCESS,
        });

        resolve({ imageUrl: payload.pictureResponse.uncroppedImageUrl });
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.UPLOAD_PREVIEW_AVATAR_IMAGE_FAILURE, error: ex });
        reject(ex.message);
      }
    });
  };
};

export const saveAndCropPreviewAvatarImage = ({x, y, width}) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SAVE_AND_CROP_AVATAR_IMAGE });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const { data: { payload, status } } = await api.auroraPut('profile/picture', {
          x,
          y,
          width,
          userId: currentUser.userId,
        });

        if (!status.success) {
          throw new Error(status.message);
        }

        dispatch({
          type: actionTypes.SAVE_AND_CROP_AVATAR_IMAGE_SUCCESS,
          profileImageSmall: payload.pictureResponse.userImageUrlSmall,
          profileImageMedium: payload.pictureResponse.userImageUrlMedium,
        });
        resolve({ imageUrl: payload.pictureResponse.userImageUrlSmall });
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.SAVE_AND_CROP_AVATAR_IMAGE_FAILURE, error: ex });
        reject(ex.message);
      }
    });
  };
};

export const uploadPreviewBannerImage = (formData) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.UPLOAD_PREVIEW_BANNER_IMAGE });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        formData.append('userId', currentUser.userId);
        const { data: { payload, status } } = await api.auroraPost('profile/banner', formData);

        if (!status.success) {
          throw new Error(status.message);
        }

        dispatch({
          type: actionTypes.UPLOAD_PREVIEW_BANNER_IMAGE_SUCCESS,
        });
        resolve({ imageUrl: payload.userBanner.uncroppedImageUrl });
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.UPLOAD_PREVIEW_BANNER_IMAGE_FAILURE, error: ex });
        reject(ex.message);
      }
    });
  };
};

export const saveAndCropPreviewBannerImage = ({x, y, width, height}) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SAVE_AND_CROP_BANNER_IMAGE });
    return new Promise(async (resolve, reject) => {
      try {
        const state = getState();
        const currentUser = state.context.currentUser;
        const { data: { payload, status } } = await api.auroraPut('profile/banner', {
          x,
          y,
          width,
          height,
          userId: currentUser.userId,
        });

        if (!status.success) {
          throw new Error(status.message);
        }

        dispatch({
          type: actionTypes.SAVE_AND_CROP_BANNER_IMAGE_SUCCESS,
        });
        resolve({ imageUrl: payload.userBanner.bannerUrl });
      } catch (ex) {
        log.error(ex);
        dispatch({ type: actionTypes.SAVE_AND_CROP_BANNER_IMAGE_FAILURE, error: ex });
        reject(ex.message);
      }
    });
  };
};
